const color = {
  blackPrimary: "rgba(5, 5, 5, 1)",
  greenPrimary: "rgba(155, 181, 55, 1)",
  greyPrimary: "rgba(206, 205, 205, 1)",
  greySecondary: "rgba(5, 5, 5, 0.5)",
  greyText:"rgba(5, 5, 5, 0.8)",
  grayBorder: "rgba(5, 5, 5, 0.2)",
  greyInput: "rgba(5, 5, 5, 0.3)",
  black:"rgba(5, 5, 5, 0.8)",
  greyTheme:"rgba(255, 255, 255, 0.5)"

  
};

export default color;